import { FilterModel } from '@helios/filter-modal'
import {
  Account,
  AccountListAggregate,
  AccountsRequestContext,
  AccountsSetValues,
  AdvancedFilters,
} from '@helios/generic-components'
import { HeliosServerSideRequest } from '@helios/server-side-util'
import { Observable } from 'rxjs'
import { GetAccountsResponse } from './http-account-list.service'

export interface ExportExcelRequest {
  fields: string[]
  headers: string[]
  filters: FilterModel
  context: AccountsRequestContext
  userTimeZone: string
}

export interface ReconAIRequest {
  accountId: number
  reconDate: string
}

export interface AdvancedFilterContext {
  /**
   * The recon date filter does nothing on its own. It provides context for other filters.
   * Currently this gives context to filters: hasOmegaDate, hasReconTimestamp & hasTradingReconTimestamp
   */
  reconDate: Date | string
  advancedFilters: AdvancedFilters
}

export const ReconDateBasedFilters: (keyof AdvancedFilters)[] = [
  'hasOmegaDate',
  'hasTradingReconTimestamp',
]

export type AccountOwnerField = 'opsManager' | 'reconciler' | 'manager'

export abstract class AccountListService {
  abstract getAccounts(
    request: HeliosServerSideRequest<Account, AccountsRequestContext>,
  ): Observable<Account[]>

  abstract getAccountsSetValues(): Observable<AccountsSetValues>
  abstract getAggregates(accountId: number): Observable<AccountListAggregate[]>
  abstract getAccountById(
    accountId: number,
    fields: (keyof Account)[],
    advancedFilterContext: AdvancedFilterContext,
  ): Observable<Account[]>
  abstract getAccountIds(
    request: HeliosServerSideRequest<Account, AccountsRequestContext>,
  ): Observable<number[]>
  abstract getAccountsExportExcel(request: ExportExcelRequest): Observable<Blob>
  abstract runAIForAccount(request: ReconAIRequest): Observable<string>
  abstract getAccountIdsForFilterAction(
    request: HeliosServerSideRequest<Account, AccountsRequestContext>,
    filterCount: number,
  ): Observable<GetAccountsResponse[]>
  abstract getNeedsOmegaTsCount(
    reconDate: Date,
    userNames: string[],
    field: AccountOwnerField,
  ): Observable<number>

  abstract getAccountListCountForFilter(
    request: HeliosServerSideRequest<Account, AccountsRequestContext>,
  ): Observable<number>

  abstract refreshAccount(accountId: number): Promise<void>
}
